import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

function Navbar() {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(i18n.language); 
  const menuRef = useRef(null);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


    useEffect(() => {
      if (i18n.language === "fa" || selectedLang === "fa") {
        document.body.classList.add("farsi-lang");
      } else {
        document.body.classList.remove("farsi-lang");
      }
    }, [i18n.language, selectedLang]);
  

  // Close menu if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close menu when a link is clicked
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar" ref={menuRef}>
      <div className="translation-buttons farsi-text">
        {["en", "de", "fa"].map((lang, index, array) => (
          <span key={lang} className="lang-wrapper">
            <button
              onClick={() => {
                changeLanguage(lang);
                handleLinkClick();
              }}
              className={selectedLang === lang ? "selected-lang" : ""}
              aria-label={`Switch language to ${lang === 'fa' ? 'Farsi' : lang.toUpperCase()}`}
            >
              {lang === "fa" ? (
                <span lang="fa">فارسی</span> 
              ) : (
                lang.toUpperCase()
              )}
            </button>
            {index < array.length - 1 && <span className="separator">/</span>}
          </span>
        ))}
      </div>

      <button 
      onClick={toggleMenu} 
      className="menu-button" 
      aria-label="Toggle navigation menu">
        {t("navbar.menu")}
      </button>

      {/* Dropdown menu */}
      {isMenuOpen && (
        <div className="menu-dropdown" role="navigation" aria-label="Main navigation menu">
          <ul>
            <li><a href="/" onClick={handleLinkClick}>{t("navbar.main")}</a></li>
            <li><a href="#bio" onClick={handleLinkClick}>{t("navbar.bio")}</a></li>
            <li><a href="#contact" onClick={handleLinkClick}>{t("navbar.contact")}</a></li>
          </ul>
          <div className="menu-divider"></div>
          <div className="menu-footer">
            <div className="menu-links">
              <img
                src="/images/icon-arrow.svg"
                alt="Arrow icon indicating more options"
                className="arrow-svg-icon"
              />
              <a href="/de/" className="animated-link" onClick={handleLinkClick}>
                <span className="menu-link">info@farzadcheshk.com</span>
              </a>
            </div>

            <div className="translation-buttons only-mobile">
              {["en", "de", "fa"].map((lang, index, array) => (
                <span key={lang} className="lang-wrapper">
                  <button
                    onClick={() => {
                      changeLanguage(lang)
                      handleLinkClick();
                    }}
                    className={selectedLang === lang ? "selected-lang" : ""}
                    aria-label={`Switch language to ${lang === 'fa' ? 'Farsi' : lang.toUpperCase()}`}
                  >
                    {lang === "fa" ? (
                  <span lang="fa">فارسی</span> 
                  ) : (
                    lang.toUpperCase()
                  )}
                  </button>
                  {index < array.length - 1 && (
                    <span className="separator">/</span>
                  )}
                </span>
              ))}
            </div>

            {/* <div className="menu-links only-desktop">
              <img
                src="/images/icon-arrow.svg"
                alt="Arrow icon indicating more options"
                className="arrow-svg-icon"
              />
              <a href="/fa/" className="animated-link" onClick={handleLinkClick}>
                <span className="menu-link">Farsi</span>
              </a>
            </div> */}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
